module.exports = __webpack_public_path__ + "img/zzsh_list.75bd6f2b.png";